import { render } from "./ExamScore.vue?vue&type=template&id=3966d918&scoped=true"
import script from "./ExamScore.vue?vue&type=script&lang=js"
export * from "./ExamScore.vue?vue&type=script&lang=js"

import "./ExamScore.vue?vue&type=style&index=0&id=3966d918&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3966d918"]])

export default __exports__